import axios from "axios";

const apiKey = process.env.REACT_APP_API;

const axiosInstance = axios.create({
  baseURL: apiKey,
});

export default axiosInstance;
